import type { IconName } from '../components/ui/index.js';

/** Icon and tone for an audit action. Shared by the overview feed and the audit list. */
export function activityIcon(action: string): { name: IconName; tone: string } {
  if (
    action.includes('deleted') ||
    action.includes('revoked') ||
    action.includes('rejected') ||
    action.includes('failed') ||
    action.includes('removed')
  ) {
    return { name: 'alert', tone: 'bg-rose-50 text-rose-600' };
  }
  if (action.startsWith('sync.') || action.endsWith('.activated') || action.endsWith('.paired')) {
    return { name: 'check', tone: 'bg-emerald-50 text-emerald-600' };
  }
  if (action.startsWith('member.') || action.startsWith('auth.')) {
    return { name: 'users', tone: 'bg-blue-50 text-blue-600' };
  }
  if (action.startsWith('lead.')) return { name: 'mail', tone: 'bg-blue-50 text-blue-600' };
  if (
    action.startsWith('bot.') ||
    action.startsWith('preview.') ||
    action.startsWith('conversation.')
  ) {
    return { name: 'chat', tone: 'bg-blue-50 text-blue-600' };
  }
  if (action.startsWith('subscription.') || action.startsWith('plan.')) {
    return { name: 'layers', tone: 'bg-blue-50 text-blue-600' };
  }
  if (action.startsWith('pairing.') || action.startsWith('installation.')) {
    return { name: 'key', tone: 'bg-blue-50 text-blue-600' };
  }
  return { name: 'globe', tone: 'bg-blue-50 text-blue-600' };
}
